import React from "react";
import { SettingsRecord } from "../repositories/types";

interface SettingsContextValue {
  settings: SettingsRecord | undefined;
  updateSettings: (s: SettingsRecord) => void;
}

export const SettingsContext = React.createContext<SettingsContextValue>({
  settings: undefined,
  updateSettings: () => {},
});
